const updateGeoZoneList = (list, updatedGeoZone) => {
  const geoZoneIndex = list.findIndex((gz) => gz.geozoneId === updatedGeoZone.geozoneId);
  if (geoZoneIndex !== -1) {
    const newGeoZones = [...list];
    newGeoZones[geoZoneIndex] = updatedGeoZone;
    return newGeoZones;
  }
  return list;
};

export default updateGeoZoneList;
